import { authorisedFetch } from 'api/rest/authorisedFetch';
import { PAYMENTS_API_URL } from 'data/constants';
import { Merchant } from 'data/merchant/models';
import { parseItemStrict } from 'utils/parser/parseResponse';

export async function getCurrentMerchantUser() {
  const result = await authorisedFetch(`${PAYMENTS_API_URL}/account`, {
    method: 'GET',
  });

  if (result.status > 399) {
    const responseBody = await result.text();
    throw new Error(`Failed to get account: ${responseBody}`);
  }

  // Must go below previous response reading (in case of error)
  const data = await result.json();

  return parseItemStrict(Merchant, data.account);
}
